import store from "@/store";

export default async (to, from, next) => {
  if (store.getters["auth/role"] !== "user") {
    return next(from.path);
  }

  return next();
};
